// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1ijL_","tab":"ProcedureTabs_tab__1fQoa"};